// extracted by mini-css-extract-plugin
module.exports = {"main":"MobileStats_main__2iTuw","isLoadingStats":"MobileStats_isLoadingStats__2c85l"};